<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="Cover Page">
<div class="coverpage"><img alt="Cover Page" src="images/cover.jpg"/></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?3c4e9a8a